export { default as ParcelTrackingBatchesViewPage} from './batches-view-page'